import { render, staticRenderFns } from "./AddShopForm.vue?vue&type=template&id=4721f055&scoped=true&"
import script from "./AddShopForm.vue?vue&type=script&lang=ts&"
export * from "./AddShopForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4721f055",
  null
  
)

export default component.exports